export enum ErrorSeverity {
  INFO = "info",
  WARNING = "warning", // Developers will be notified
  ERROR = "error", // Everyone will be notified
}
